/* template */
<template><div :class='("package_batch "+(unfold ? "unfold" : ""))' :id="('package_batch_' + goods.goods_id)"><div :class='("batch_list "+(couponPackage.length > 2 ? "add_margin": ""))' :id="('batch_list_' + goods.goods_id)"><div :class='("batch_item "+(goods.balance_left === 0 ? "text_light": ""))' v-for="(item, index) in (couponPackage)" :key="item.index" v-if="(item.textLight)">{{item.textLight}}</div></div><mpx-text @tap.stop="toggleBatch(goods)" class="icon_arrow" v-if="(showArrow)"></mpx-text></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6f9d6f7c"}'>
.package_batch {
  position: relative
  height: 55rpx
  overflow: hidden

  .batch_list {
    font-size: 0
    overflow: hidden
    color: #666

    &.add_margin {
      margin-right: 20rpx
    }

    .batch_item {
      display: inline-block;
      height: 50rpx
      line-height 50rpx
      font-size: 22rpx
      padding: 0 12rpx
      box-sizing: border-box
      border-radius: 4rpx
      border: 1rpx solid rgba(0, 0, 0, 0.1)
      margin-right: 6rpx
      margin-bottom: 6rpx
      background: rgba(243,244,245,0.78)
      border: 1px solid #FDFDFD
      border-radius: 4px
      color: #4E4E4E


      &:after {
        border-radius: 4rpx
      }

      p {
        margin-top: 0
        font-family: PingFangSC-Regular
        color: #666
        line-height: 22rpx

        &.text_light {
          opacity: 0.6
        }
      }

      .left_info {
        margin-top: 6rpx
        line-height: 22rpx
        color: #FC9153
      }
    }
  }
  &.unfold {
    .icon_arrow {
      transform: rotate(-90deg)
      background-position: center bottom
    }
    height: auto
  }
  .icon_arrow {
    position: absolute
    right: 0
    top: 0
    transform: rotate(90deg)
    width: 50rpx
    height: 50rpx
    background-size: 10rpx 18rpx
    background-position: center top
    background-repeat: no-repeat
    background-image: url(https://dpubstatic.udache.com/static/dpubimg/9B-gkgBDQ3/icon_arrow.png)
  }
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
createComponent({
  attached() {
    setTimeout(() => {
      mpx.createSelectorQuery().in(this).select('#package_batch_' + this.goods.goods_id).boundingClientRect(resP => {
        mpx.createSelectorQuery().in(this).select('#batch_list_' + this.goods.goods_id).boundingClientRect(resC => {
          if (resP.height * 2 <= resC.height) {
            this.showArrow = true
          }
        }).exec()
      }).exec()
    }, 300)
  },
  properties: {
    goods: {
      type: Object,
      value: function() {
        return {
          goods: {},
        }
      },
    },
  },
  data: {
    showArrow: false,
    unfold: false,
  },
  computed: {
    couponPackage() {
      if (!this.goods?.package?.length) {
        return []
      }
      return this.goods.package.map(item => {
        return {
          ...item,
          textLight: item.product_id === 104 ? item.title_v1 :  item.text1_v1 ||item.product_desc_v1,
        }
      })
    },
  },
  methods: {
    toggleBatch() {
      this.unfold = !this.unfold
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "text-package6f9d6f7c",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-text':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
